import {createSvgIcon} from '../create-svg-icon';

export const SouthEastIcon = createSvgIcon(
  <path d="M19 9h-2v6.59L5.41 4 4 5.41 15.59 17H9v2h10V9z" />
, 'SouthEastOutlined');
